import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const FORM = derivedThemeValues(_ref => {
  let {
    theme,
    remCalc
  } = _ref;
  return {
    slider: {
      height: remCalc(4),
      rail: {
        color: '#e2e5eb',
        backgroundColor: '#ffffff'
      },
      track: {
        color: '#3259e8'
      },
      tooltip: {
        lineHeight: remCalc(16),
        fontSize: remCalc(12),
        fontWeight: theme.base.fontSemibold,
        fontColor: '#626d7c',
        backgroundColor: '#e2e5eb',
        borderColor: '#c3c9d1',
        borderRadius: remCalc(4)
      },
      handle: {
        size: remCalc(16),
        offset: remCalc(-6),
        borderWidth: remCalc(4),
        borderColor: '#3259e8',
        draggingColor: '#6ea9db'
      },
      mark: {
        fontSize: remCalc(14),
        lineHeight: remCalc(16),
        fontWeight: theme.base.fontRegular,
        fontColor: '#626d7c'
      }
    },
    radioButton: {
      verticalPadding: remCalc(8),
      horizontalPadding: remCalc(16),
      radius: remCalc(8),
      borderColor: '#c3c9d1',
      active: {
        borderColor: '#3259e8',
        color: '#3259e8',
        fontColor: '#ffffff'
      }
    },
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: remCalc(14),
      lineHeight: remCalc(16),
      fontWeight: theme.base.fontRegular,
      color: theme.color.bodyFont
    },
    caption: {
      fontSize: remCalc(14),
      lineHeight: remCalc(16),
      fontWeight: theme.base.fontRegular,
      color: theme.color.gray600
    },
    input: {
      fontFamily: theme.typography.fontFamily,
      fontSize: remCalc(16),
      lineHeight: remCalc(24),
      fontWeight: theme.base.fontRegular,
      fontColor: theme.color.bodyFont,
      backgroundColor: theme.color.bodyBackground,
      paddingLeft: remCalc(16),
      paddingRight: remCalc(16),
      paddingTop: remCalc(12),
      paddingBottom: remCalc(12),
      borderWidth: remCalc(1),
      borderColor: theme.color.border,
      borderColorHover: theme.color.borderHover,
      outlineWidth: remCalc(1),
      outlineOffset: remCalc(0),
      placeholder: {
        color: theme.color.mutedFont,
        fontFamily: theme.typography.fontFamily,
        fontSize: remCalc(16),
        fontWeight: theme.base.fontRegular,
        lineHeight: remCalc(24)
      }
    },
    dropdown: {
      offset: remCalc(6),
      shadow: '0px 6px 12px 0px rgba(0, 0, 0, 0.1)',
      backgroundColor: theme.color.bodyBackground,
      borderColor: theme.color.border,
      divider: {
        color: 'transparent'
      },
      link: {
        verticalPadding: remCalc(8),
        horizontalPadding: remCalc(16),
        fontSize: remCalc(16),
        lineHeight: remCalc(24)
      }
    }
  };
});